import { useContext, useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { LoadingDataRequestsType, Vehicle, VehicleAttribute } from '../../types';
import styles from '../SearchByLaximoVinContainer.module.scss';
import { SearchVehicleByVinDataContext } from '../../SearchVehicleByVinDataProvider';

interface VehicleRowProps {
	vehicle: Vehicle;
	vehicleAttributes: VehicleAttribute[];
}

/**
 * Компонент для отображения строки транспортного средства
 * @param vehicle - транспортное средство
 * @param vehicleAttributes - атрибуты транспортного средства
 */
const VehicleRow = ({ vehicle, vehicleAttributes }: VehicleRowProps) => {
	const [showAll, setShowAll] = useState(false);
	const { findVehicle } = useContext(SearchVehicleByVinDataContext) as LoadingDataRequestsType;

	return (
		<TableRow className={styles.activeRow}>
			{vehicleAttributes.map(vehicleAttribute => (
				<TableCell 
					key={vehicleAttribute.key} 
					style={{padding: 5}} 
					className={styles.vehicleCell} 
					onClick={() => findVehicle(vehicle)}
				>
					{showAll ? vehicleAttribute.value : vehicleAttribute.value.substring(0, 50)}
					{vehicleAttribute.value.length > 50 ? (
						showAll ? 
							<div style={{cursor: 'pointer', color: '#5983ff'}} onClick={() => setShowAll(false)}>
								Скрыть
							</div> : 
							<div style={{cursor: 'pointer', color: '#5983ff'}} onClick={() => setShowAll(true)}>
								Подробнее
							</div>
					) : null}
				</TableCell>
			))}
		</TableRow>
	);
};

export default VehicleRow; 